/**
 * EOFY Slim Banner — Countdown Timer & Dismiss
 * Vanilla JS, no dependencies, Shopify OS 2.0 compatible.
 */
(function () {
  'use strict';

  function pad(num) {
    return String(num).padStart(2, '0');
  }

  function parseEndDate(value) {
    var d = new Date(value);
    if (!isNaN(d.getTime())) return d;

    var match = /^(\d{4})-(\d{1,2})-(\d{1,2})T(\d{1,2}):(\d{1,2}):(\d{1,2})/.exec(value || '');
    if (match) {
      d = new Date(
        parseInt(match[1], 10),
        parseInt(match[2], 10) - 1,
        parseInt(match[3], 10),
        parseInt(match[4], 10),
        parseInt(match[5], 10),
        parseInt(match[6], 10)
      );
      if (!isNaN(d.getTime())) return d;
    }

    return null;
  }

  function initCountdown(el) {
    if (el.dataset.eofySlimInitialised === 'true') return;
    el.dataset.eofySlimInitialised = 'true';

    var endAttr = el.getAttribute('data-end');
    if (!endAttr) return;

    var endDate = parseEndDate(endAttr);
    if (!endDate) {
      return;
    }

    var timerWrap = el.querySelector('[data-eofy-slim-timer]');
    var labelEl = el.querySelector('.eofy-slim__countdown-label');
    var endedEl = el.querySelector('[data-eofy-slim-ended]');

    var daysEl = el.querySelector('[data-eofy-slim-days]');
    var hoursEl = el.querySelector('[data-eofy-slim-hours]');
    var minutesEl = el.querySelector('[data-eofy-slim-minutes]');
    var secondsEl = el.querySelector('[data-eofy-slim-seconds]');

    var intervalId = null;

    function showEnded() {
      if (timerWrap) timerWrap.hidden = true;
      if (labelEl) labelEl.hidden = true;
      if (endedEl) endedEl.hidden = false;
      if (intervalId) clearInterval(intervalId);
    }

    function tick() {
      var now = new Date().getTime();
      var distance = endDate.getTime() - now;

      if (distance <= 0) {
        showEnded();
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    intervalId = setInterval(tick, 1000);
  }

  function initDismiss(banner) {
    var closeBtn = banner.querySelector('[data-eofy-slim-close]');
    if (!closeBtn || closeBtn.dataset.eofySlimInitialised === 'true') return;
    closeBtn.dataset.eofySlimInitialised = 'true';

    var storageKey = 'eofy-slim-dismissed-' + banner.id;

    try {
      if (sessionStorage.getItem(storageKey) === 'true') {
        banner.classList.add('eofy-slim--dismissed');
      }
    } catch (e) {
      /* sessionStorage unavailable, ignore */
    }

    closeBtn.addEventListener('click', function () {
      banner.classList.add('eofy-slim--dismissed');
      try {
        sessionStorage.setItem(storageKey, 'true');
      } catch (e) {
        /* sessionStorage unavailable, ignore */
      }
    });
  }

  function initBanner(banner) {
    var countdownEl = banner.querySelector('[data-eofy-slim-countdown]');
    if (countdownEl) initCountdown(countdownEl);
    initDismiss(banner);
  }

  function initAll() {
    var banners = document.querySelectorAll('.eofy-slim');
    banners.forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var banner = event.target.querySelector('.eofy-slim');
    if (banner) initBanner(banner);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var banner = event.target.querySelector('.eofy-slim');
    if (banner) initBanner(banner);
  });
})();